module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.fill_info == '') ? _c('div', [_c('div', {
    staticClass: "row",
    staticStyle: {
      "display": "flex",
      "flex-wrap": "wrap"
    }
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "form-title"
  }, [_vm._v(_vm._s(_vm.form.name))])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "info-box download",
    staticStyle: {
      "margin-bottom": "0px"
    }
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": 'assets/files/' + _vm.form.info_pdf_file,
      "title": "Pályázati felhívás letöltés"
    }
  }, [_c('span', {
    staticClass: "highlight"
  }, [_vm._v("Pályázati felhívás")]), _vm._v(" letöltés\n            ")])])]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  }, [_c('inputbox', {
    attrs: {
      "label": "Doktori kutatási téma címe",
      "errors": _vm.errors,
      "id": "doktori_kutatas_tema_cime",
      "name": "doktori_kutatas_tema_cime",
      "regexp_filter": "[a-zA-ZöüóőúéáűíÖÜÓŐÚÉÁŰÍ .0-9]+"
    },
    model: {
      value: (_vm.form.values.doktori_kutatas_tema_cime),
      callback: function($$v) {
        _vm.form.values.doktori_kutatas_tema_cime = $$v
      },
      expression: "form.values.doktori_kutatas_tema_cime"
    }
  })], 1), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6"
  }, [_c('inputbox', {
    attrs: {
      "label": "Titulus",
      "errors": _vm.errors,
      "id": "titulus",
      "name": "titulus",
      "regexp_filter": "[a-zA-ZöüóőúéáűíÖÜÓŐÚÉÁŰÍ .-]+"
    },
    model: {
      value: (_vm.form.values.titulus),
      callback: function($$v) {
        _vm.form.values.titulus = $$v
      },
      expression: "form.values.titulus"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6"
  }, [_c('inputbox', {
    attrs: {
      "label": "Név",
      "errors": _vm.errors,
      "id": "nev",
      "name": "nev",
      "regexp_filter": "[a-zA-ZöüóőúéáűíÖÜÓŐÚÉÁŰÍ .-]+"
    },
    model: {
      value: (_vm.form.values.nev),
      callback: function($$v) {
        _vm.form.values.nev = $$v
      },
      expression: "form.values.nev"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6"
  }, [_c('inputbox', {
    attrs: {
      "label": "Születési név",
      "errors": _vm.errors,
      "id": "szuletesi_nev",
      "name": "szuletesi_nev",
      "regexp_filter": "[a-zA-ZöüóőúéáűíÖÜÓŐÚÉÁŰÍ .]+"
    },
    model: {
      value: (_vm.form.values.szuletesi_nev),
      callback: function($$v) {
        _vm.form.values.szuletesi_nev = $$v
      },
      expression: "form.values.szuletesi_nev"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6"
  }, [_c('inputbox', {
    attrs: {
      "label": "Neptunkód",
      "errors": _vm.errors,
      "regexp_filter": "[a-zA-Z0-9]+",
      "id": "neptunkod",
      "name": "neptunkod"
    },
    model: {
      value: (_vm.form.values.neptunkod),
      callback: function($$v) {
        _vm.form.values.neptunkod = $$v
      },
      expression: "form.values.neptunkod"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6"
  }, [_c('inputbox', {
    attrs: {
      "label": "Születési hely",
      "errors": _vm.errors,
      "regexp_filter": "[a-zA-ZöüóőúéáűíÖÜÓŐÚÉÁŰÍ]+",
      "id": "szuletesi_hely",
      "name": "szuletesi_hely"
    },
    model: {
      value: (_vm.form.values.szuletesi_hely),
      callback: function($$v) {
        _vm.form.values.szuletesi_hely = $$v
      },
      expression: "form.values.szuletesi_hely"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6"
  }, [_c('inputbox', {
    attrs: {
      "autocomplete": "off",
      "datepicker": true,
      "datepickeropts": {
        'yearRange': '-100:+0',
        'changeYear': 'true',
        'changeMonth': 'true'
      },
      "label": "Születési idő",
      "errors": _vm.errors,
      "id": "szuletesi_ido",
      "name": "szuletesi_ido"
    },
    model: {
      value: (_vm.form.values.szuletesi_ido),
      callback: function($$v) {
        _vm.form.values.szuletesi_ido = $$v
      },
      expression: "form.values.szuletesi_ido"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6"
  }, [_c('inputbox', {
    attrs: {
      "label": "Anyja leánykori neve",
      "errors": _vm.errors,
      "id": "anyja_leanykori_neve",
      "name": "anyja_leanykori_neve",
      "regexp_filter": "[a-zA-ZöüóőúéáűíÖÜÓŐÚÉÁŰÍ .]+"
    },
    model: {
      value: (_vm.form.values.anyja_leanykori_neve),
      callback: function($$v) {
        _vm.form.values.anyja_leanykori_neve = $$v
      },
      expression: "form.values.anyja_leanykori_neve"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6"
  }, [_c('comboboxV2', {
    attrs: {
      "errors": _vm.errors,
      "label": "Nem",
      "id": "nemi_kategoria",
      "name": "nemi_kategoria",
      "options": _vm.nemi_kategoriak
    },
    model: {
      value: (_vm.form.values.nemi_kategoria),
      callback: function($$v) {
        _vm.form.values.nemi_kategoria = $$v
      },
      expression: "form.values.nemi_kategoria"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6"
  }, [_c('inputbox', {
    attrs: {
      "label": "Állampolgárság",
      "errors": _vm.errors,
      "id": "allampolgarsag",
      "name": "allampolgarsag",
      "regexp_filter": "[a-zA-ZöüóőúéáűíÖÜÓŐÚÉÁŰÍ]+"
    },
    model: {
      value: (_vm.form.values.allampolgarsag),
      callback: function($$v) {
        _vm.form.values.allampolgarsag = $$v
      },
      expression: "form.values.allampolgarsag"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6"
  }, [_c('inputbox', {
    attrs: {
      "label": "Adóazonosító jel",
      "errors": _vm.errors,
      "id": "adoazonosito_jel",
      "name": "adoazonosito_jel",
      "regexp_filter": "[0-9-]+"
    },
    model: {
      value: (_vm.form.values.adoazonosito_jel),
      callback: function($$v) {
        _vm.form.values.adoazonosito_jel = $$v
      },
      expression: "form.values.adoazonosito_jel"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6"
  }, [_c('inputbox', {
    attrs: {
      "label": "Email cím",
      "errors": _vm.errors,
      "id": "email",
      "name": "email",
      "regexp_filter": "[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,}"
    },
    model: {
      value: (_vm.form.values.email),
      callback: function($$v) {
        _vm.form.values.email = $$v
      },
      expression: "form.values.email"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6"
  }, [_c('inputbox', {
    attrs: {
      "label": "Telefonszám",
      "errors": _vm.errors,
      "id": "telefonszam",
      "name": "telefonszam",
      "regexp_filter": "[+0-9 /-]+"
    },
    model: {
      value: (_vm.form.values.telefonszam),
      callback: function($$v) {
        _vm.form.values.telefonszam = $$v
      },
      expression: "form.values.telefonszam"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6"
  }, [_c('inputbox', {
    attrs: {
      "label": "Állandó lakcím",
      "errors": _vm.errors,
      "id": "allando_lakcim",
      "name": "allando_lakcim"
    },
    model: {
      value: (_vm.form.values.allando_lakcim),
      callback: function($$v) {
        _vm.form.values.allando_lakcim = $$v
      },
      expression: "form.values.allando_lakcim"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6"
  }, [_c('inputbox', {
    attrs: {
      "label": "Levelezési cím",
      "errors": _vm.errors,
      "id": "levelezesi_cim",
      "name": "levelezesi_cim"
    },
    model: {
      value: (_vm.form.values.levelezesi_cim),
      callback: function($$v) {
        _vm.form.values.levelezesi_cim = $$v
      },
      expression: "form.values.levelezesi_cim"
    }
  })], 1), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6"
  }, [_c('comboboxV2', {
    attrs: {
      "errors": _vm.errors,
      "label": "Doktori hallgatói munkarend",
      "id": "doktori_hallgatoi_munkarend",
      "name": "doktori_hallgatoi_munkarend",
      "options": _vm.doktori_hallgatoi_munkarendek
    },
    model: {
      value: (_vm.form.values.doktori_hallgatoi_munkarend),
      callback: function($$v) {
        _vm.form.values.doktori_hallgatoi_munkarend = $$v
      },
      expression: "form.values.doktori_hallgatoi_munkarend"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6"
  }, [_c('comboboxV2', {
    attrs: {
      "errors": _vm.errors,
      "label": "Doktori képzés finanszírozási forma",
      "id": "doktori_kepzes_finansziorzasi_forma",
      "name": "doktori_kepzes_finansziorzasi_forma",
      "options": _vm.doktori_kepzes_finansziorzasi_formak
    },
    model: {
      value: (_vm.form.values.doktori_kepzes_finansziorzasi_forma),
      callback: function($$v) {
        _vm.form.values.doktori_kepzes_finansziorzasi_forma = $$v
      },
      expression: "form.values.doktori_kepzes_finansziorzasi_forma"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6"
  }, [_c('comboboxV2', {
    attrs: {
      "errors": _vm.errors,
      "label": "A sikeresen befejezett szemeszterek száma",
      "id": "szemeszterek_szama",
      "name": "szemeszterek_szama",
      "options": _vm.szemeszterek_szama
    },
    model: {
      value: (_vm.form.values.szemeszterek_szama),
      callback: function($$v) {
        _vm.form.values.szemeszterek_szama = $$v
      },
      expression: "form.values.szemeszterek_szama"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6"
  }, [_c('comboboxV2', {
    attrs: {
      "errors": _vm.errors,
      "label": "A doktori tanulmányok kezdetének féléve",
      "id": "doktori_tanulmanyok_kezdet_felev",
      "name": "doktori_tanulmanyok_kezdet_felev",
      "options": _vm.doktori_tanulmanyok_kezdet_felevek
    },
    model: {
      value: (_vm.form.values.doktori_tanulmanyok_kezdet_felev),
      callback: function($$v) {
        _vm.form.values.doktori_tanulmanyok_kezdet_felev = $$v
      },
      expression: "form.values.doktori_tanulmanyok_kezdet_felev"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6"
  }, [_c('comboboxV2', {
    attrs: {
      "errors": _vm.errors,
      "label": "Komplex vizsga teljesítésének várható féléve",
      "id": "komplex_vizsga_teljesitesenyek_feleve",
      "name": "komplex_vizsga_teljesitesenyek_feleve",
      "options": _vm.komplex_vizsga_teljesitesenyek_felevek
    },
    model: {
      value: (_vm.form.values.komplex_vizsga_teljesitesenyek_feleve),
      callback: function($$v) {
        _vm.form.values.komplex_vizsga_teljesitesenyek_feleve = $$v
      },
      expression: "form.values.komplex_vizsga_teljesitesenyek_feleve"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6"
  }, [_c('comboboxV2', {
    attrs: {
      "errors": _vm.errors,
      "label": "Doktori képzés keretében az abszolutórium megszerzésének várható féléve",
      "id": "abszolutorium_megszerzesenek_varhato_feleve",
      "name": "abszolutorium_megszerzesenek_varhato_feleve",
      "options": _vm.abszolutorium_megszerzesenek_varhato_felevek
    },
    model: {
      value: (_vm.form.values.abszolutorium_megszerzesenek_varhato_feleve),
      callback: function($$v) {
        _vm.form.values.abszolutorium_megszerzesenek_varhato_feleve = $$v
      },
      expression: "form.values.abszolutorium_megszerzesenek_varhato_feleve"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6"
  }, [_c('inputbox', {
    attrs: {
      "autocomplete": "off",
      "datepicker": true,
      "datepickeropts": {
        'yearRange': '-0:+10',
        'changeYear': 'true',
        'changeMonth': 'true'
      },
      "label": "A doktori értekezés vagy a doktori iskola által kért, azzal egyenértékű alkotás benyújtásának várható időpontja",
      "errors": _vm.errors,
      "id": "alkotas_benyujtasanak_idopontja",
      "name": "alkotas_benyujtasanak_idopontja"
    },
    model: {
      value: (_vm.form.values.alkotas_benyujtasanak_idopontja),
      callback: function($$v) {
        _vm.form.values.alkotas_benyujtasanak_idopontja = $$v
      },
      expression: "form.values.alkotas_benyujtasanak_idopontja"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6"
  }, [_c('inputbox', {
    attrs: {
      "disabled": true,
      "datepicker": true,
      "datepickeropts": {
        'yearRange': '-0:+10',
        'changeYear': 'true',
        'changeMonth': 'true'
      },
      "label": "Az EKÖP-KDP ösztöndíjas jogviszony kezdetének időpontja",
      "errors": _vm.errors,
      "id": "osztondijas_jogviszony_kezdete",
      "name": "osztondijas_jogviszony_kezdete"
    },
    model: {
      value: (_vm.form.values.osztondijas_jogviszony_kezdete),
      callback: function($$v) {
        _vm.form.values.osztondijas_jogviszony_kezdete = $$v
      },
      expression: "form.values.osztondijas_jogviszony_kezdete"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6"
  }, [_c('comboboxV2', {
    attrs: {
      "errors": _vm.errors,
      "label": "Pályázott ösztöndíjas jogviszony időtartama (hónap)",
      "id": "osztondijas_jogviszony_idotartam",
      "name": "osztondijas_jogviszony_idotartam",
      "options": _vm.osztondijas_jogviszony_idotartamok
    },
    on: {
      "onChange": _vm.osztondijasJogviszonyIdotartamValtozik
    },
    model: {
      value: (_vm.form.values.osztondijas_jogviszony_idotartam),
      callback: function($$v) {
        _vm.form.values.osztondijas_jogviszony_idotartam = $$v
      },
      expression: "form.values.osztondijas_jogviszony_idotartam"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6"
  }, [_c('inputbox', {
    attrs: {
      "disabled": true,
      "label": "Pályázott ösztöndíjas jogviszony vége",
      "errors": _vm.errors,
      "id": "osztondijas_jogviszony_vege",
      "name": "osztondijas_jogviszony_vege"
    },
    model: {
      value: (_vm.form.values.osztondijas_jogviszony_vege),
      callback: function($$v) {
        _vm.form.values.osztondijas_jogviszony_vege = $$v
      },
      expression: "form.values.osztondijas_jogviszony_vege"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6"
  }, [_c('inputbox', {
    attrs: {
      "disabled": true,
      "label": "A megpályázott KDP ösztöndíj havi összege (Ft)",
      "errors": _vm.errors,
      "id": "osztondij_havi_osszege",
      "name": "osztondij_havi_osszege",
      "regexp_filter": "[0-9]+"
    },
    model: {
      value: (_vm.form.values.osztondij_havi_osszege),
      callback: function($$v) {
        _vm.form.values.osztondij_havi_osszege = $$v
      },
      expression: "form.values.osztondij_havi_osszege"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6"
  }, [_c('inputbox', {
    attrs: {
      "disabled": true,
      "label": "Megpályázott támogatás összesen (Ft)",
      "errors": _vm.errors,
      "id": "megpalyazott_tamogatas_osszesen",
      "name": "megpalyazott_tamogatas_osszesen",
      "regexp_filter": "[0-9]+"
    },
    model: {
      value: (_vm.form.values.megpalyazott_tamogatas_osszesen),
      callback: function($$v) {
        _vm.form.values.megpalyazott_tamogatas_osszesen = $$v
      },
      expression: "form.values.megpalyazott_tamogatas_osszesen"
    }
  })], 1), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  }, [_c('comboboxV2', {
    attrs: {
      "errors": _vm.errors,
      "label": "Fogadó doktori iskola neve",
      "id": "fogado_doktori_iskola_neve",
      "name": "fogado_doktori_iskola_neve",
      "options": _vm.doktori_iskolak
    },
    model: {
      value: (_vm.form.values.fogado_doktori_iskola_neve),
      callback: function($$v) {
        _vm.form.values.fogado_doktori_iskola_neve = $$v
      },
      expression: "form.values.fogado_doktori_iskola_neve"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6"
  }, [_c('inputbox', {
    attrs: {
      "label": "A fogadó doktori iskola vezetőjének neve",
      "errors": _vm.errors,
      "id": "fogado_doktori_iskola_vezeto_nev",
      "name": "fogado_doktori_iskola_vezeto_nev",
      "regexp_filter": "[a-zA-ZöüóőúéáűíÖÜÓŐÚÉÁŰÍ .]+"
    },
    model: {
      value: (_vm.form.values.fogado_doktori_iskola_vezeto_nev),
      callback: function($$v) {
        _vm.form.values.fogado_doktori_iskola_vezeto_nev = $$v
      },
      expression: "form.values.fogado_doktori_iskola_vezeto_nev"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6"
  }, [_c('inputbox', {
    attrs: {
      "label": "A fogadó doktori iskola kapcsolattartójának neve",
      "errors": _vm.errors,
      "id": "fogado_doktori_iskola_kapcsolattarto_nev",
      "name": "fogado_doktori_iskola_kapcsolattarto_nev",
      "regexp_filter": "[a-zA-ZöüóőúéáűíÖÜÓŐÚÉÁŰÍ .]+"
    },
    model: {
      value: (_vm.form.values.fogado_doktori_iskola_kapcsolattarto_nev),
      callback: function($$v) {
        _vm.form.values.fogado_doktori_iskola_kapcsolattarto_nev = $$v
      },
      expression: "form.values.fogado_doktori_iskola_kapcsolattarto_nev"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  }, [_c('radiosV2', {
    attrs: {
      "errors": _vm.errors,
      "label": "Nyilatkozat a pályázó jogviszonyáról",
      "id": "palyazo_jogviszony_nyilatkozat",
      "name": "palyazo_jogviszony_nyilatkozat",
      "items": _vm.palyazo_jogviszony_nyilatkozatok
    },
    model: {
      value: (_vm.form.values.palyazo_jogviszony_nyilatkozat),
      callback: function($$v) {
        _vm.form.values.palyazo_jogviszony_nyilatkozat = $$v
      },
      expression: "form.values.palyazo_jogviszony_nyilatkozat"
    }
  })], 1), _vm._v(" "), _vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6"
  }, [_c('inputbox', {
    attrs: {
      "label": "A témavezető titulusa",
      "errors": _vm.errors,
      "id": "temavezeto_titulus",
      "name": "temavezeto_titulus",
      "regexp_filter": "[a-zA-ZöüóőúéáűíÖÜÓŐÚÉÁŰÍ .]+"
    },
    model: {
      value: (_vm.form.values.temavezeto_titulus),
      callback: function($$v) {
        _vm.form.values.temavezeto_titulus = $$v
      },
      expression: "form.values.temavezeto_titulus"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6"
  }, [_c('inputbox', {
    attrs: {
      "label": "A témavezető neve",
      "errors": _vm.errors,
      "id": "temavezeto_neve",
      "name": "temavezeto_neve",
      "regexp_filter": "[a-zA-ZöüóőúéáűíÖÜÓŐÚÉÁŰÍ .]+"
    },
    model: {
      value: (_vm.form.values.temavezeto_neve),
      callback: function($$v) {
        _vm.form.values.temavezeto_neve = $$v
      },
      expression: "form.values.temavezeto_neve"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6"
  }, [_c('comboboxV2', {
    attrs: {
      "errors": _vm.errors,
      "label": "A témavezető tudományos fokozata",
      "id": "temavezeto_tudomanyos_fokozata",
      "name": "temavezeto_tudomanyos_fokozata",
      "options": _vm.tudomanyos_fokozatok
    },
    model: {
      value: (_vm.form.values.temavezeto_tudomanyos_fokozata),
      callback: function($$v) {
        _vm.form.values.temavezeto_tudomanyos_fokozata = $$v
      },
      expression: "form.values.temavezeto_tudomanyos_fokozata"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6"
  }, [_c('comboboxV2', {
    attrs: {
      "errors": _vm.errors,
      "label": "A témavezető tudományos fokozatának megszerzési éve",
      "id": "temavezeto_tudomanyos_fokozatanak_megszerzesi_eve",
      "name": "temavezeto_tudomanyos_fokozatanak_megszerzesi_eve",
      "options": _vm.temavezeto_tudomanyos_fokozatanak_megszerzesi_evek
    },
    model: {
      value: (_vm.form.values.temavezeto_tudomanyos_fokozatanak_megszerzesi_eve),
      callback: function($$v) {
        _vm.form.values.temavezeto_tudomanyos_fokozatanak_megszerzesi_eve = $$v
      },
      expression: "form.values.temavezeto_tudomanyos_fokozatanak_megszerzesi_eve"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6"
  }, [_c('inputbox', {
    attrs: {
      "label": "A témavezető adóazonosító száma",
      "errors": _vm.errors,
      "id": "temavezeto_adoazonosito_szam",
      "name": "temavezeto_adoazonosito_szam",
      "regexp_filter": "[0-9-]+"
    },
    model: {
      value: (_vm.form.values.temavezeto_adoazonosito_szam),
      callback: function($$v) {
        _vm.form.values.temavezeto_adoazonosito_szam = $$v
      },
      expression: "form.values.temavezeto_adoazonosito_szam"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6"
  }, [_c('inputbox', {
    attrs: {
      "label": "A témavezető beosztása",
      "errors": _vm.errors,
      "id": "temavezeto_beosztas",
      "name": "temavezeto_beosztas",
      "regexp_filter": "[a-zA-ZöüóőúéáűíÖÜÓŐÚÉÁŰÍ .]+"
    },
    model: {
      value: (_vm.form.values.temavezeto_beosztas),
      callback: function($$v) {
        _vm.form.values.temavezeto_beosztas = $$v
      },
      expression: "form.values.temavezeto_beosztas"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6"
  }, [_c('inputbox', {
    attrs: {
      "label": "A témavezető témavezetésével a pályázat beadásáig fokozatot szerzettek száma",
      "errors": _vm.errors,
      "id": "temavezeto_temavezetesevel_palyazat_beadasaig_fokozatott_szerzettek_szama",
      "name": "temavezeto_temavezetesevel_palyazat_beadasaig_fokozatott_szerzettek_szama",
      "regexp_filter": "[0-9]+"
    },
    model: {
      value: (_vm.form.values.temavezeto_temavezetesevel_palyazat_beadasaig_fokozatott_szerzettek_szama),
      callback: function($$v) {
        _vm.form.values.temavezeto_temavezetesevel_palyazat_beadasaig_fokozatott_szerzettek_szama = $$v
      },
      expression: "form.values.temavezeto_temavezetesevel_palyazat_beadasaig_fokozatott_szerzettek_szama"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6"
  }, [_c('inputbox', {
    attrs: {
      "label": "A témavezető folyamatban lévő doktori témavezetéseinek száma",
      "errors": _vm.errors,
      "id": "temavezeto_folyamatban_levo_doktori_temavezeteseinek_szama",
      "name": "temavezeto_folyamatban_levo_doktori_temavezeteseinek_szama",
      "regexp_filter": "[0-9]+"
    },
    model: {
      value: (_vm.form.values.temavezeto_folyamatban_levo_doktori_temavezeteseinek_szama),
      callback: function($$v) {
        _vm.form.values.temavezeto_folyamatban_levo_doktori_temavezeteseinek_szama = $$v
      },
      expression: "form.values.temavezeto_folyamatban_levo_doktori_temavezeteseinek_szama"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  }, [_c('inputbox', {
    attrs: {
      "label": "A témavezető kutatási területének megnevezése",
      "errors": _vm.errors,
      "id": "temavezeto_kutatasi_terulete",
      "name": "temavezeto_kutatasi_terulete",
      "regexp_filter": "[a-zA-ZöüóőúéáűíÖÜÓŐÚÉÁŰÍ .]+"
    },
    model: {
      value: (_vm.form.values.temavezeto_kutatasi_terulete),
      callback: function($$v) {
        _vm.form.values.temavezeto_kutatasi_terulete = $$v
      },
      expression: "form.values.temavezeto_kutatasi_terulete"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  }, [_c('textareabox', {
    attrs: {
      "autogrow": true,
      "maxlength": "5000",
      "label": "A témavezető eddigi tudományos és kutatási teljesítményének bemutatása (legalább 2000 és legfeljebb 5000 karakter terjedelemben)",
      "errors": _vm.errors,
      "id": "temavezeto_kutatasi_teljesitmenyenek_bemutatasa",
      "name": "temavezeto_kutatasi_teljesitmenyenek_bemutatasa"
    },
    model: {
      value: (_vm.form.values.temavezeto_kutatasi_teljesitmenyenek_bemutatasa),
      callback: function($$v) {
        _vm.form.values.temavezeto_kutatasi_teljesitmenyenek_bemutatasa = $$v
      },
      expression: "form.values.temavezeto_kutatasi_teljesitmenyenek_bemutatasa"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6"
  }, [_c('inputbox', {
    attrs: {
      "label": "A témavezető MTMT azonosítója",
      "errors": _vm.errors,
      "id": "temavezeto_mtmt_azonosito",
      "name": "temavezeto_mtmt_azonosito",
      "regexp_filter": "[0-9]+"
    },
    model: {
      value: (_vm.form.values.temavezeto_mtmt_azonosito),
      callback: function($$v) {
        _vm.form.values.temavezeto_mtmt_azonosito = $$v
      },
      expression: "form.values.temavezeto_mtmt_azonosito"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6"
  }, [_c('inputbox', {
    attrs: {
      "label": "A témavezető e-mail címe",
      "errors": _vm.errors,
      "id": "temavezeto_email",
      "name": "temavezeto_email",
      "regexp_filter": "[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,}"
    },
    model: {
      value: (_vm.form.values.temavezeto_email),
      callback: function($$v) {
        _vm.form.values.temavezeto_email = $$v
      },
      expression: "form.values.temavezeto_email"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6"
  }, [_c('inputbox', {
    attrs: {
      "label": "A témavezető telefonszáma",
      "errors": _vm.errors,
      "id": "temavezeto_telefonszam",
      "name": "temavezeto_telefonszam",
      "regexp_filter": "[+0-9 /-]+"
    },
    model: {
      value: (_vm.form.values.temavezeto_telefonszam),
      callback: function($$v) {
        _vm.form.values.temavezeto_telefonszam = $$v
      },
      expression: "form.values.temavezeto_telefonszam"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  }, [_c('UploadHandler', {
    attrs: {
      "max_uploaded_files": "1",
      "accepted_files": "application/pdf,application/x-pdf",
      "errors": _vm.errors,
      "label": "A témavezető szakmai és tudományos önéletrajza",
      "id": "temavezeto_oneletrajza",
      "name": "temavezeto_oneletrajza",
      "loaded_files": _vm.form.values.temavezeto_oneletrajza
    },
    on: {
      "change": function (value) {
        _vm.changeValue(value, 'temavezeto_oneletrajza');
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  }, [_c('UploadHandler', {
    attrs: {
      "max_uploaded_files": "1",
      "accepted_files": "application/pdf,application/x-pdf",
      "errors": _vm.errors,
      "label": "A pályázó doktori témája és kutatási terve tudományos megalapozottságának írásbeli értékelése (minimum 2000 karakter)",
      "id": "palyazo_doktori_temaja_es_kutatasi_terve_tudomanyos_megalapozottsaganak_irasbeli_ertekelese",
      "name": "palyazo_doktori_temaja_es_kutatasi_terve_tudomanyos_megalapozottsaganak_irasbeli_ertekelese",
      "loaded_files": _vm.form.values.palyazo_doktori_temaja_es_kutatasi_terve_tudomanyos_megalapozottsaganak_irasbeli_ertekelese
    },
    on: {
      "change": function (value) {
        _vm.changeValue(value, 'palyazo_doktori_temaja_es_kutatasi_terve_tudomanyos_megalapozottsaganak_irasbeli_ertekelese');
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  }, [_c('UploadHandler', {
    attrs: {
      "max_uploaded_files": "1",
      "accepted_files": "application/pdf,application/x-pdf",
      "errors": _vm.errors,
      "label": "Publikációs lista",
      "id": "temavezeto_publikacios_lista",
      "name": "temavezeto_publikacios_lista",
      "loaded_files": _vm.form.values.temavezeto_publikacios_lista
    },
    on: {
      "change": function (value) {
        _vm.changeValue(value, 'temavezeto_publikacios_lista');
      }
    }
  })], 1), _vm._v(" "), _vm._m(5), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6"
  }, [_c('inputbox', {
    attrs: {
      "label": "A munkáltató megnevezése",
      "errors": _vm.errors,
      "id": "munkaltato_megnevezese",
      "name": "munkaltato_megnevezese"
    },
    model: {
      value: (_vm.form.values.munkaltato_megnevezese),
      callback: function($$v) {
        _vm.form.values.munkaltato_megnevezese = $$v
      },
      expression: "form.values.munkaltato_megnevezese"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6"
  }, [_c('inputbox', {
    attrs: {
      "label": "A munkáltató képviselőjének neve",
      "errors": _vm.errors,
      "id": "munkaltato_kepviselo_nev",
      "name": "munkaltato_kepviselo_nev",
      "regexp_filter": "[a-zA-ZöüóőúéáűíÖÜÓŐÚÉÁŰÍ .]+"
    },
    model: {
      value: (_vm.form.values.munkaltato_kepviselo_nev),
      callback: function($$v) {
        _vm.form.values.munkaltato_kepviselo_nev = $$v
      },
      expression: "form.values.munkaltato_kepviselo_nev"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6"
  }, [_c('inputbox', {
    attrs: {
      "label": "A munkáltató székhelye",
      "errors": _vm.errors,
      "id": "munkaltato_szekhelye",
      "name": "munkaltato_szekhelye"
    },
    model: {
      value: (_vm.form.values.munkaltato_szekhelye),
      callback: function($$v) {
        _vm.form.values.munkaltato_szekhelye = $$v
      },
      expression: "form.values.munkaltato_szekhelye"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6"
  }, [_c('comboboxV2', {
    attrs: {
      "errors": _vm.errors,
      "label": "A munkáltató besorolása a pályázati kiírás 5.2 pontja alapján",
      "id": "munkaltato_besorolasa",
      "name": "munkaltato_besorolasa",
      "options": _vm.munkaltato_besorolasok
    },
    model: {
      value: (_vm.form.values.munkaltato_besorolasa),
      callback: function($$v) {
        _vm.form.values.munkaltato_besorolasa = $$v
      },
      expression: "form.values.munkaltato_besorolasa"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6"
  }, [_c('inputbox', {
    attrs: {
      "label": "A munkáltató cégjegyzékszáma/nyilvántartási száma",
      "errors": _vm.errors,
      "id": "munkaltato_cegjegyzekszam",
      "name": "munkaltato_cegjegyzekszam",
      "regexp_filter": "[0-9 -]+"
    },
    model: {
      value: (_vm.form.values.munkaltato_cegjegyzekszam),
      callback: function($$v) {
        _vm.form.values.munkaltato_cegjegyzekszam = $$v
      },
      expression: "form.values.munkaltato_cegjegyzekszam"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6"
  }, [_c('inputbox', {
    attrs: {
      "label": "A munkáltató adószáma",
      "errors": _vm.errors,
      "id": "munkaltato_adoszam",
      "name": "munkaltato_adoszam",
      "regexp_filter": "[0-9 -]+"
    },
    model: {
      value: (_vm.form.values.munkaltato_adoszam),
      callback: function($$v) {
        _vm.form.values.munkaltato_adoszam = $$v
      },
      expression: "form.values.munkaltato_adoszam"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  }, [_c('textareabox', {
    attrs: {
      "autogrow": true,
      "maxlength": "5000",
      "label": "A munkáltató bemutatása, kitérve a tudományos teljesítmények és eredmények gyakorlati hasznosíthatóságát elősegítő tevékenységére",
      "errors": _vm.errors,
      "id": "munkaltato_bemutatasa",
      "name": "munkaltato_bemutatasa"
    },
    model: {
      value: (_vm.form.values.munkaltato_bemutatasa),
      callback: function($$v) {
        _vm.form.values.munkaltato_bemutatasa = $$v
      },
      expression: "form.values.munkaltato_bemutatasa"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6"
  }, [_c('inputbox', {
    attrs: {
      "label": "A munkáltatónál kutatói munkakörben foglalkoztatottak száma 2020-ban",
      "errors": _vm.errors,
      "id": "munkaltato_foglalkoztatottak_szama_1",
      "name": "munkaltato_foglalkoztatottak_szama_1",
      "regexp_filter": "[0-9]+"
    },
    model: {
      value: (_vm.form.values.munkaltato_foglalkoztatottak_szama_1),
      callback: function($$v) {
        _vm.form.values.munkaltato_foglalkoztatottak_szama_1 = $$v
      },
      expression: "form.values.munkaltato_foglalkoztatottak_szama_1"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6"
  }, [_c('inputbox', {
    attrs: {
      "label": "A munkáltatónál kutatói munkakörben foglalkoztatottak száma 2021-ben",
      "errors": _vm.errors,
      "id": "munkaltato_foglalkoztatottak_szama_2",
      "name": "munkaltato_foglalkoztatottak_szama_2",
      "regexp_filter": "[0-9]+"
    },
    model: {
      value: (_vm.form.values.munkaltato_foglalkoztatottak_szama_2),
      callback: function($$v) {
        _vm.form.values.munkaltato_foglalkoztatottak_szama_2 = $$v
      },
      expression: "form.values.munkaltato_foglalkoztatottak_szama_2"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6"
  }, [_c('inputbox', {
    attrs: {
      "label": "A munkáltatónál kutatói munkakörben foglalkoztatottak száma 2022-ben",
      "errors": _vm.errors,
      "id": "munkaltato_foglalkoztatottak_szama_3",
      "name": "munkaltato_foglalkoztatottak_szama_3",
      "regexp_filter": "[0-9]+"
    },
    model: {
      value: (_vm.form.values.munkaltato_foglalkoztatottak_szama_3),
      callback: function($$v) {
        _vm.form.values.munkaltato_foglalkoztatottak_szama_3 = $$v
      },
      expression: "form.values.munkaltato_foglalkoztatottak_szama_3"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6"
  }, [_c('inputbox', {
    attrs: {
      "label": "A munkáltatónál kutatói munkakörben foglalkoztatottak száma 2023-ban",
      "errors": _vm.errors,
      "id": "munkaltato_foglalkoztatottak_szama_4",
      "name": "munkaltato_foglalkoztatottak_szama_4",
      "regexp_filter": "[0-9]+"
    },
    model: {
      value: (_vm.form.values.munkaltato_foglalkoztatottak_szama_4),
      callback: function($$v) {
        _vm.form.values.munkaltato_foglalkoztatottak_szama_4 = $$v
      },
      expression: "form.values.munkaltato_foglalkoztatottak_szama_4"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6"
  }, [_c('inputbox', {
    attrs: {
      "label": "A munkáltatónál kutatói munkakörben foglalkoztatottak száma 2024-ben",
      "errors": _vm.errors,
      "id": "munkaltato_foglalkoztatottak_szama_5",
      "name": "munkaltato_foglalkoztatottak_szama_5",
      "regexp_filter": "[0-9]+"
    },
    model: {
      value: (_vm.form.values.munkaltato_foglalkoztatottak_szama_5),
      callback: function($$v) {
        _vm.form.values.munkaltato_foglalkoztatottak_szama_5 = $$v
      },
      expression: "form.values.munkaltato_foglalkoztatottak_szama_5"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6"
  }, [_c('inputbox', {
    attrs: {
      "label": "A munkáltató kapcsolattartójának neve",
      "errors": _vm.errors,
      "id": "munkaltato_kapcsolattarto_nev",
      "name": "munkaltato_kapcsolattarto_nev",
      "regexp_filter": "[a-zA-ZöüóőúéáűíÖÜÓŐÚÉÁŰÍ .]+"
    },
    model: {
      value: (_vm.form.values.munkaltato_kapcsolattarto_nev),
      callback: function($$v) {
        _vm.form.values.munkaltato_kapcsolattarto_nev = $$v
      },
      expression: "form.values.munkaltato_kapcsolattarto_nev"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6"
  }, [_c('inputbox', {
    attrs: {
      "label": "A munkáltató kapcsolattartójának telefonszáma",
      "errors": _vm.errors,
      "id": "munkaltato_kapcsolattarto_telefonszam",
      "name": "munkaltato_kapcsolattarto_telefonszam",
      "regexp_filter": "[+0-9 /-]+"
    },
    model: {
      value: (_vm.form.values.munkaltato_kapcsolattarto_telefonszam),
      callback: function($$v) {
        _vm.form.values.munkaltato_kapcsolattarto_telefonszam = $$v
      },
      expression: "form.values.munkaltato_kapcsolattarto_telefonszam"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6"
  }, [_c('inputbox', {
    attrs: {
      "label": "A munkáltató kapcsolattartójának e-mail címe",
      "errors": _vm.errors,
      "id": "munkaltato_kapcsolattarto_email",
      "name": "munkaltato_kapcsolattarto_email",
      "regexp_filter": "[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,}"
    },
    model: {
      value: (_vm.form.values.munkaltato_kapcsolattarto_email),
      callback: function($$v) {
        _vm.form.values.munkaltato_kapcsolattarto_email = $$v
      },
      expression: "form.values.munkaltato_kapcsolattarto_email"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  }, [_c('comboboxV2', {
    attrs: {
      "errors": _vm.errors,
      "label": "Munkaviszony/munkavégzésre irányuló egyéb jogviszony típusa",
      "id": "munkaviszony_iranyulo_egyeb_jogviszony_tipus",
      "name": "munkaviszony_iranyulo_egyeb_jogviszony_tipus",
      "options": _vm.munkaviszony_iranyulo_egyeb_jogviszony_tipusok
    },
    model: {
      value: (_vm.form.values.munkaviszony_iranyulo_egyeb_jogviszony_tipus),
      callback: function($$v) {
        _vm.form.values.munkaviszony_iranyulo_egyeb_jogviszony_tipus = $$v
      },
      expression: "form.values.munkaviszony_iranyulo_egyeb_jogviszony_tipus"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6"
  }, [_c('inputbox', {
    attrs: {
      "autocomplete": "off",
      "datepicker": true,
      "datepickeropts": {
        'yearRange': '-100:+0',
        'changeYear': 'true',
        'changeMonth': 'true'
      },
      "label": "Munkaviszony/munkavégzésre irányuló egyéb jogviszony kezdete",
      "errors": _vm.errors,
      "id": "munkaviszony_iranyulo_egyeb_jogviszony_kezdete",
      "name": "munkaviszony_iranyulo_egyeb_jogviszony_kezdete"
    },
    model: {
      value: (_vm.form.values.munkaviszony_iranyulo_egyeb_jogviszony_kezdete),
      callback: function($$v) {
        _vm.form.values.munkaviszony_iranyulo_egyeb_jogviszony_kezdete = $$v
      },
      expression: "form.values.munkaviszony_iranyulo_egyeb_jogviszony_kezdete"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6"
  }, [_c('comboboxV2', {
    attrs: {
      "errors": _vm.errors,
      "label": "Foglalkoztatás típusa",
      "id": "foglalkoztatas_tipusa",
      "name": "foglalkoztatas_tipusa",
      "options": _vm.foglalkoztatas_tipusok
    },
    model: {
      value: (_vm.form.values.foglalkoztatas_tipusa),
      callback: function($$v) {
        _vm.form.values.foglalkoztatas_tipusa = $$v
      },
      expression: "form.values.foglalkoztatas_tipusa"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6"
  }, [_c('comboboxV2', {
    attrs: {
      "errors": _vm.errors,
      "label": "Munkaviszony/munkavégzésre irányuló egyéb jogviszony időtartama",
      "id": "munkaviszony_iranyulo_egyeb_jogviszony_idotartam",
      "name": "munkaviszony_iranyulo_egyeb_jogviszony_idotartam",
      "options": _vm.munkaviszony_idotartamok
    },
    model: {
      value: (_vm.form.values.munkaviszony_iranyulo_egyeb_jogviszony_idotartam),
      callback: function($$v) {
        _vm.form.values.munkaviszony_iranyulo_egyeb_jogviszony_idotartam = $$v
      },
      expression: "form.values.munkaviszony_iranyulo_egyeb_jogviszony_idotartam"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  }, [_c('radiosV2', {
    attrs: {
      "errors": _vm.errors,
      "label": "Nyilatkozat a szakértő munkaviszonyáról",
      "id": "nyilatkozat_szakerto_munkaviszony",
      "name": "nyilatkozat_szakerto_munkaviszony",
      "items": _vm.nyilatkozat_szakerto_munkaviszony_opciok
    },
    model: {
      value: (_vm.form.values.nyilatkozat_szakerto_munkaviszony),
      callback: function($$v) {
        _vm.form.values.nyilatkozat_szakerto_munkaviszony = $$v
      },
      expression: "form.values.nyilatkozat_szakerto_munkaviszony"
    }
  })], 1), _vm._v(" "), _vm._m(6), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6"
  }, [_c('inputbox', {
    attrs: {
      "label": "A szakértő titulusa",
      "errors": _vm.errors,
      "id": "szakerto_titulusa",
      "name": "szakerto_titulusa",
      "regexp_filter": "[a-zA-ZöüóőúéáűíÖÜÓŐÚÉÁŰÍ .]+"
    },
    model: {
      value: (_vm.form.values.szakerto_titulusa),
      callback: function($$v) {
        _vm.form.values.szakerto_titulusa = $$v
      },
      expression: "form.values.szakerto_titulusa"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6"
  }, [_c('inputbox', {
    attrs: {
      "label": "A szakértő neve",
      "errors": _vm.errors,
      "id": "szakerto_neve",
      "name": "szakerto_neve",
      "regexp_filter": "[a-zA-ZöüóőúéáűíÖÜÓŐÚÉÁŰÍ .]+"
    },
    model: {
      value: (_vm.form.values.szakerto_neve),
      callback: function($$v) {
        _vm.form.values.szakerto_neve = $$v
      },
      expression: "form.values.szakerto_neve"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6"
  }, [_c('comboboxV2', {
    attrs: {
      "errors": _vm.errors,
      "label": "A szakértő tudományos fokozata (amennyiben releváns)",
      "id": "szakerto_tudomanyos_fokozata",
      "name": "szakerto_tudomanyos_fokozata",
      "options": _vm.tudomanyos_fokozatok
    },
    model: {
      value: (_vm.form.values.szakerto_tudomanyos_fokozata),
      callback: function($$v) {
        _vm.form.values.szakerto_tudomanyos_fokozata = $$v
      },
      expression: "form.values.szakerto_tudomanyos_fokozata"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6"
  }, [_c('comboboxV2', {
    attrs: {
      "errors": _vm.errors,
      "label": "A szakértő tudományos fokozatának megszerzési éve (amennyiben releváns)",
      "id": "szakerto_tudomanyos_fokozat_megszerzes_eve",
      "name": "szakerto_tudomanyos_fokozat_megszerzes_eve",
      "options": _vm.szakerto_tudomanyos_fokozatanak_megszerzesi_evek
    },
    model: {
      value: (_vm.form.values.szakerto_tudomanyos_fokozat_megszerzes_eve),
      callback: function($$v) {
        _vm.form.values.szakerto_tudomanyos_fokozat_megszerzes_eve = $$v
      },
      expression: "form.values.szakerto_tudomanyos_fokozat_megszerzes_eve"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6"
  }, [_c('inputbox', {
    attrs: {
      "label": "A szakértő adóazonosító száma",
      "errors": _vm.errors,
      "id": "szakerto_adoazonosito_szam",
      "name": "szakerto_adoazonosito_szam",
      "regexp_filter": "[0-9-]+"
    },
    model: {
      value: (_vm.form.values.szakerto_adoazonosito_szam),
      callback: function($$v) {
        _vm.form.values.szakerto_adoazonosito_szam = $$v
      },
      expression: "form.values.szakerto_adoazonosito_szam"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6"
  }, [_c('inputbox', {
    attrs: {
      "label": "A szakértő beosztása",
      "errors": _vm.errors,
      "id": "szakerto_beosztasa",
      "name": "szakerto_beosztasa",
      "regexp_filter": "[a-zA-ZöüóőúéáűíÖÜÓŐÚÉÁŰÍ .]+"
    },
    model: {
      value: (_vm.form.values.szakerto_beosztasa),
      callback: function($$v) {
        _vm.form.values.szakerto_beosztasa = $$v
      },
      expression: "form.values.szakerto_beosztasa"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6"
  }, [_c('inputbox', {
    attrs: {
      "label": "A szakértő releváns szakmai tapasztalati éveinek száma",
      "errors": _vm.errors,
      "id": "szakerto_szakmai_tapasztalat_eveinek_szama",
      "name": "szakerto_szakmai_tapasztalat_eveinek_szama",
      "regexp_filter": "[0-9]+"
    },
    model: {
      value: (_vm.form.values.szakerto_szakmai_tapasztalat_eveinek_szama),
      callback: function($$v) {
        _vm.form.values.szakerto_szakmai_tapasztalat_eveinek_szama = $$v
      },
      expression: "form.values.szakerto_szakmai_tapasztalat_eveinek_szama"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6"
  }, [_c('inputbox', {
    attrs: {
      "label": "A szakértő MTMT azonosítója (amennyiben rendelkezik MTMT azonosítóval)",
      "errors": _vm.errors,
      "id": "szakerto_mtmt_azonosito",
      "name": "szakerto_mtmt_azonosito",
      "regexp_filter": "[0-9]+"
    },
    model: {
      value: (_vm.form.values.szakerto_mtmt_azonosito),
      callback: function($$v) {
        _vm.form.values.szakerto_mtmt_azonosito = $$v
      },
      expression: "form.values.szakerto_mtmt_azonosito"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  }, [_c('textareabox', {
    attrs: {
      "autogrow": true,
      "maxlength": "5000",
      "label": "A szakértőnek a tudományos eredmények gyakorlati hasznosíthatóság területén szerzett tapasztalatainak bemutatása (legalább 2000 és legfeljebb 5000 karakter terjedelemben)",
      "errors": _vm.errors,
      "id": "szakerto_tudomanyos_eredmenyek_hasznosithatosag_bemutatasa",
      "name": "szakerto_tudomanyos_eredmenyek_hasznosithatosag_bemutatasa"
    },
    model: {
      value: (_vm.form.values.szakerto_tudomanyos_eredmenyek_hasznosithatosag_bemutatasa),
      callback: function($$v) {
        _vm.form.values.szakerto_tudomanyos_eredmenyek_hasznosithatosag_bemutatasa = $$v
      },
      expression: "form.values.szakerto_tudomanyos_eredmenyek_hasznosithatosag_bemutatasa"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6"
  }, [_c('inputbox', {
    attrs: {
      "label": "A szakértő e-mail címe",
      "errors": _vm.errors,
      "id": "szakerto_email_cim",
      "name": "szakerto_email_cim",
      "regexp_filter": "[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,}"
    },
    model: {
      value: (_vm.form.values.szakerto_email_cim),
      callback: function($$v) {
        _vm.form.values.szakerto_email_cim = $$v
      },
      expression: "form.values.szakerto_email_cim"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6"
  }, [_c('inputbox', {
    attrs: {
      "label": "A szakértő telefonszáma",
      "errors": _vm.errors,
      "id": "szakerto_telefonszam",
      "name": "szakerto_telefonszam",
      "regexp_filter": "[+0-9 /-]+"
    },
    model: {
      value: (_vm.form.values.szakerto_telefonszam),
      callback: function($$v) {
        _vm.form.values.szakerto_telefonszam = $$v
      },
      expression: "form.values.szakerto_telefonszam"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  }, [_c('UploadHandler', {
    attrs: {
      "max_uploaded_files": "1",
      "accepted_files": "application/pdf,application/x-pdf",
      "errors": _vm.errors,
      "label": "A szakértő szakmai és tudományos önéletrajza",
      "id": "szakerto_oneletrajz",
      "name": "szakerto_oneletrajz",
      "loaded_files": _vm.form.values.szakerto_oneletrajz
    },
    on: {
      "change": function (value) {
        _vm.changeValue(value, 'szakerto_oneletrajz');
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  }, [_c('UploadHandler', {
    attrs: {
      "max_uploaded_files": "1",
      "accepted_files": "application/pdf,application/x-pdf",
      "errors": _vm.errors,
      "label": "A pályázó doktori témája és kutatási terve vállalati relevanciájának és hasznosíthatóságának értékelése (mininum 2000 karakter)",
      "id": "palyazo_kutatasi_terve_vallalati_hasznosithatosag_ertekelese",
      "name": "palyazo_kutatasi_terve_vallalati_hasznosithatosag_ertekelese",
      "loaded_files": _vm.form.values.palyazo_kutatasi_terve_vallalati_hasznosithatosag_ertekelese
    },
    on: {
      "change": function (value) {
        _vm.changeValue(value, 'palyazo_kutatasi_terve_vallalati_hasznosithatosag_ertekelese');
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  }, [_c('UploadHandler', {
    attrs: {
      "max_uploaded_files": "1",
      "accepted_files": "application/pdf,application/x-pdf",
      "errors": _vm.errors,
      "label": "A szakértő - pályázati kiírásban előírt – végzettségét igazoló okirat",
      "id": "szakerto_vegzettseget_igazolo_okirat",
      "name": "szakerto_vegzettseget_igazolo_okirat",
      "loaded_files": _vm.form.values.szakerto_vegzettseget_igazolo_okirat
    },
    on: {
      "change": function (value) {
        _vm.changeValue(value, 'szakerto_vegzettseget_igazolo_okirat');
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  }, [_c('UploadHandler', {
    attrs: {
      "max_uploaded_files": "1",
      "accepted_files": "application/pdf,application/x-pdf",
      "errors": _vm.errors,
      "label": "A szakértő tudományos fokozatát igazoló dokumentum",
      "id": "szakerto_tudomanyos_fokozat_igazolo_dokumentum",
      "name": "szakerto_tudomanyos_fokozat_igazolo_dokumentum",
      "loaded_files": _vm.form.values.szakerto_tudomanyos_fokozat_igazolo_dokumentum
    },
    on: {
      "change": function (value) {
        _vm.changeValue(value, 'szakerto_tudomanyos_fokozat_igazolo_dokumentum');
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  }, [_c('UploadHandler', {
    attrs: {
      "max_uploaded_files": "1",
      "accepted_files": "application/pdf,application/x-pdf",
      "errors": _vm.errors,
      "label": "Publikációs lista",
      "id": "szakerto_publikacios_lista",
      "name": "szakerto_publikacios_lista",
      "loaded_files": _vm.form.values.szakerto_publikacios_lista
    },
    on: {
      "change": function (value) {
        _vm.changeValue(value, 'szakerto_publikacios_lista');
      }
    }
  })], 1), _vm._v(" "), _vm._m(7), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6"
  }, [_c('inputbox', {
    attrs: {
      "label": "Végzettség megnevezése",
      "errors": _vm.errors,
      "id": "vegzettseg_megnevezese",
      "name": "vegzettseg_megnevezese",
      "regexp_filter": "[a-zA-ZöüóőúéáűíÖÜÓŐÚÉÁŰÍ .]+"
    },
    model: {
      value: (_vm.form.values.vegzettseg_megnevezese),
      callback: function($$v) {
        _vm.form.values.vegzettseg_megnevezese = $$v
      },
      expression: "form.values.vegzettseg_megnevezese"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6"
  }, [_c('inputbox', {
    attrs: {
      "label": "Intézmény neve",
      "errors": _vm.errors,
      "id": "vegzettseg_intezmeny_nev",
      "name": "vegzettseg_intezmeny_nev",
      "regexp_filter": "[a-zA-ZöüóőúéáűíÖÜÓŐÚÉÁŰÍ .]+"
    },
    model: {
      value: (_vm.form.values.vegzettseg_intezmeny_nev),
      callback: function($$v) {
        _vm.form.values.vegzettseg_intezmeny_nev = $$v
      },
      expression: "form.values.vegzettseg_intezmeny_nev"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6"
  }, [_c('inputbox', {
    attrs: {
      "label": "Kar neve",
      "errors": _vm.errors,
      "id": "vegzettseg_kar_nev",
      "name": "vegzettseg_kar_nev",
      "regexp_filter": "[a-zA-ZöüóőúéáűíÖÜÓŐÚÉÁŰÍ .]+"
    },
    model: {
      value: (_vm.form.values.vegzettseg_kar_nev),
      callback: function($$v) {
        _vm.form.values.vegzettseg_kar_nev = $$v
      },
      expression: "form.values.vegzettseg_kar_nev"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6"
  }, [_c('inputbox', {
    attrs: {
      "label": "Intézmény címe",
      "errors": _vm.errors,
      "id": "vegzettseg_intezmeny_cim",
      "name": "vegzettseg_intezmeny_cim"
    },
    model: {
      value: (_vm.form.values.vegzettseg_intezmeny_cim),
      callback: function($$v) {
        _vm.form.values.vegzettseg_intezmeny_cim = $$v
      },
      expression: "form.values.vegzettseg_intezmeny_cim"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6"
  }, [_c('inputbox', {
    attrs: {
      "label": "Oklevél száma",
      "errors": _vm.errors,
      "id": "vegzettseg_oklevel_szam",
      "name": "vegzettseg_oklevel_szam"
    },
    model: {
      value: (_vm.form.values.vegzettseg_oklevel_szam),
      callback: function($$v) {
        _vm.form.values.vegzettseg_oklevel_szam = $$v
      },
      expression: "form.values.vegzettseg_oklevel_szam"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6"
  }, [_c('inputbox', {
    attrs: {
      "autocomplete": "off",
      "datepicker": true,
      "datepickeropts": {
        'yearRange': '-100:+0',
        'changeYear': 'true',
        'changeMonth': 'true'
      },
      "label": "Oklevél kelte",
      "errors": _vm.errors,
      "id": "vegzettseg_oklevel_kelte",
      "name": "vegzettseg_oklevel_kelte"
    },
    model: {
      value: (_vm.form.values.vegzettseg_oklevel_kelte),
      callback: function($$v) {
        _vm.form.values.vegzettseg_oklevel_kelte = $$v
      },
      expression: "form.values.vegzettseg_oklevel_kelte"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6"
  }, [_c('inputbox', {
    attrs: {
      "label": "Oklevél minősítése",
      "errors": _vm.errors,
      "id": "vegzettseg_oklevel_minosites",
      "name": "vegzettseg_oklevel_minosites"
    },
    model: {
      value: (_vm.form.values.vegzettseg_oklevel_minosites),
      callback: function($$v) {
        _vm.form.values.vegzettseg_oklevel_minosites = $$v
      },
      expression: "form.values.vegzettseg_oklevel_minosites"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6"
  }, [_c('inputbox', {
    attrs: {
      "label": "További, a kutatási témához kapcsolódó képzettség",
      "errors": _vm.errors,
      "id": "tovabbi_kepzettseg",
      "name": "tovabbi_kepzettseg"
    },
    model: {
      value: (_vm.form.values.tovabbi_kepzettseg),
      callback: function($$v) {
        _vm.form.values.tovabbi_kepzettseg = $$v
      },
      expression: "form.values.tovabbi_kepzettseg"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-4"
  }, [_c('inputbox', {
    attrs: {
      "label": "1. nyelvvizsga nyelv",
      "errors": _vm.errors,
      "id": "nyelvvizsga_1_nyelv",
      "regexp_filter": "[a-zA-ZöüóőúéáűíÖÜÓŐÚÉÁŰÍ]+",
      "name": "nyelvvizsga_1_nyelv"
    },
    on: {
      "onchange": _vm.nyelvTipusAllitas
    },
    model: {
      value: (_vm.form.values.nyelvvizsga_1_nyelv),
      callback: function($$v) {
        _vm.form.values.nyelvvizsga_1_nyelv = $$v
      },
      expression: "form.values.nyelvvizsga_1_nyelv"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-4"
  }, [_c('inputbox', {
    attrs: {
      "label": "1. nyelvvizsga típus",
      "errors": _vm.errors,
      "id": "nyelvvizsga_1_tipus",
      "regexp_filter": "[a-zA-ZöüóőúéáűíÖÜÓŐÚÉÁŰÍ]+",
      "name": "nyelvvizsga_1_tipus"
    },
    on: {
      "onchange": _vm.nyelvTipusAllitas
    },
    model: {
      value: (_vm.form.values.nyelvvizsga_1_tipus),
      callback: function($$v) {
        _vm.form.values.nyelvvizsga_1_tipus = $$v
      },
      expression: "form.values.nyelvvizsga_1_tipus"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-4"
  }, [_c('comboboxV2', {
    attrs: {
      "disabled": _vm.form.values.nyelvvizsga_1_nyelv == '' || _vm.form.values.nyelvvizsga_1_tipus == '' ? true : false,
      "errors": _vm.errors,
      "label": "1. nyelvvizsga szint",
      "id": "nyelvvizsga_1_szint",
      "name": "nyelvvizsga_1_szint",
      "options": _vm.nyelvvizsga_szintek
    },
    model: {
      value: (_vm.form.values.nyelvvizsga_1_szint),
      callback: function($$v) {
        _vm.form.values.nyelvvizsga_1_szint = $$v
      },
      expression: "form.values.nyelvvizsga_1_szint"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-4"
  }, [_c('inputbox', {
    attrs: {
      "label": "2. nyelvvizsga nyelv",
      "errors": _vm.errors,
      "id": "nyelvvizsga_2_nyelv",
      "regexp_filter": "[a-zA-ZöüóőúéáűíÖÜÓŐÚÉÁŰÍ]+",
      "name": "nyelvvizsga_2_nyelv"
    },
    on: {
      "onchange": _vm.nyelvTipusAllitas
    },
    model: {
      value: (_vm.form.values.nyelvvizsga_2_nyelv),
      callback: function($$v) {
        _vm.form.values.nyelvvizsga_2_nyelv = $$v
      },
      expression: "form.values.nyelvvizsga_2_nyelv"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-4"
  }, [_c('inputbox', {
    attrs: {
      "label": "2. nyelvvizsga típus",
      "errors": _vm.errors,
      "id": "nyelvvizsga_2_tipus",
      "regexp_filter": "[a-zA-ZöüóőúéáűíÖÜÓŐÚÉÁŰÍ]+",
      "name": "nyelvvizsga_2_tipus"
    },
    on: {
      "onchange": _vm.nyelvTipusAllitas
    },
    model: {
      value: (_vm.form.values.nyelvvizsga_2_tipus),
      callback: function($$v) {
        _vm.form.values.nyelvvizsga_2_tipus = $$v
      },
      expression: "form.values.nyelvvizsga_2_tipus"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-4"
  }, [_c('comboboxV2', {
    attrs: {
      "disabled": _vm.form.values.nyelvvizsga_2_nyelv == '' || _vm.form.values.nyelvvizsga_2_tipus == '' ? true : false,
      "errors": _vm.errors,
      "label": "2. nyelvvizsga szint",
      "id": "nyelvvizsga_2_szint",
      "name": "nyelvvizsga_2_szint",
      "options": _vm.nyelvvizsga_szintek
    },
    model: {
      value: (_vm.form.values.nyelvvizsga_2_szint),
      callback: function($$v) {
        _vm.form.values.nyelvvizsga_2_szint = $$v
      },
      expression: "form.values.nyelvvizsga_2_szint"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-4"
  }, [_c('inputbox', {
    attrs: {
      "label": "3. nyelvvizsga nyelv",
      "errors": _vm.errors,
      "id": "nyelvvizsga_3_nyelv",
      "regexp_filter": "[a-zA-ZöüóőúéáűíÖÜÓŐÚÉÁŰÍ]+",
      "name": "nyelvvizsga_3_nyelv"
    },
    on: {
      "onchange": _vm.nyelvTipusAllitas
    },
    model: {
      value: (_vm.form.values.nyelvvizsga_3_nyelv),
      callback: function($$v) {
        _vm.form.values.nyelvvizsga_3_nyelv = $$v
      },
      expression: "form.values.nyelvvizsga_3_nyelv"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-4"
  }, [_c('inputbox', {
    attrs: {
      "label": "3. nyelvvizsga típus",
      "errors": _vm.errors,
      "id": "nyelvvizsga_3_tipus",
      "regexp_filter": "[a-zA-ZöüóőúéáűíÖÜÓŐÚÉÁŰÍ]+",
      "name": "nyelvvizsga_3_tipus"
    },
    on: {
      "onchange": _vm.nyelvTipusAllitas
    },
    model: {
      value: (_vm.form.values.nyelvvizsga_3_tipus),
      callback: function($$v) {
        _vm.form.values.nyelvvizsga_3_tipus = $$v
      },
      expression: "form.values.nyelvvizsga_3_tipus"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-4"
  }, [_c('comboboxV2', {
    attrs: {
      "disabled": _vm.form.values.nyelvvizsga_3_nyelv == '' || _vm.form.values.nyelvvizsga_3_tipus == '' ? true : false,
      "errors": _vm.errors,
      "label": "3. nyelvvizsga szint",
      "id": "nyelvvizsga_3_szint",
      "name": "nyelvvizsga_3_szint",
      "options": _vm.nyelvvizsga_szintek
    },
    model: {
      value: (_vm.form.values.nyelvvizsga_3_szint),
      callback: function($$v) {
        _vm.form.values.nyelvvizsga_3_szint = $$v
      },
      expression: "form.values.nyelvvizsga_3_szint"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6"
  }, [_c('inputbox', {
    attrs: {
      "label": "MTMT azonosító",
      "errors": _vm.errors,
      "id": "palyazo_mtmt_azonosito",
      "name": "palyazo_mtmt_azonosito",
      "regexp_filter": "[0-9]+"
    },
    model: {
      value: (_vm.form.values.palyazo_mtmt_azonosito),
      callback: function($$v) {
        _vm.form.values.palyazo_mtmt_azonosito = $$v
      },
      expression: "form.values.palyazo_mtmt_azonosito"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  }, [_c('UploadHandler', {
    attrs: {
      "max_uploaded_files": "1",
      "accepted_files": "application/pdf,application/x-pdf",
      "errors": _vm.errors,
      "label": "Dokumentummal igazolható tudományos/művészeti tevékenység",
      "id": "tudomanyos_muveszeti_tevekenyseg_igazolas",
      "name": "tudomanyos_muveszeti_tevekenyseg_igazolas",
      "loaded_files": _vm.form.values.tudomanyos_muveszeti_tevekenyseg_igazolas
    },
    on: {
      "change": function (value) {
        _vm.changeValue(value, 'tudomanyos_muveszeti_tevekenyseg_igazolas');
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  }, [_c('textareabox', {
    attrs: {
      "autogrow": true,
      "maxlength": "5000",
      "label": "Dokumentummal nem igazolható tudományos/művészeti tevékenység szöveges bemutatása (amely tudományos/művészeti tevékenységet dokumentummal nem lehet igazolni, annak szöveges feltüntetését itt kérjük megadni)",
      "errors": _vm.errors,
      "id": "dokumentummal_nem_igazolhato_tudomanyos_muveszeti_tevekenyseg",
      "name": "dokumentummal_nem_igazolhato_tudomanyos_muveszeti_tevekenyseg"
    },
    model: {
      value: (_vm.form.values.dokumentummal_nem_igazolhato_tudomanyos_muveszeti_tevekenyseg),
      callback: function($$v) {
        _vm.form.values.dokumentummal_nem_igazolhato_tudomanyos_muveszeti_tevekenyseg = $$v
      },
      expression: "form.values.dokumentummal_nem_igazolhato_tudomanyos_muveszeti_tevekenyseg"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  }, [_c('UploadHandler', {
    attrs: {
      "max_uploaded_files": "1",
      "accepted_files": "application/pdf,application/x-pdf",
      "errors": _vm.errors,
      "label": "Eddigi tanulmányait/tudományos tevékenységét elismerő díjak",
      "id": "tanulmanyok_tudomanyos_tevekenysegek_dijak",
      "name": "tanulmanyok_tudomanyos_tevekenysegek_dijak",
      "loaded_files": _vm.form.values.tanulmanyok_tudomanyos_tevekenysegek_dijak
    },
    on: {
      "change": function (value) {
        _vm.changeValue(value, 'tanulmanyok_tudomanyos_tevekenysegek_dijak');
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  }, [_c('textareabox', {
    attrs: {
      "autogrow": true,
      "maxlength": "1000",
      "label": "A doktori kutatási téma rövid összefoglalása (legfeljebb 1000 karakter szóközökkel, a részletes bemutatás a kutatási terv tartalmazza)",
      "errors": _vm.errors,
      "id": "doktori_tema_rovid_osszefoglalas",
      "name": "doktori_tema_rovid_osszefoglalas"
    },
    model: {
      value: (_vm.form.values.doktori_tema_rovid_osszefoglalas),
      callback: function($$v) {
        _vm.form.values.doktori_tema_rovid_osszefoglalas = $$v
      },
      expression: "form.values.doktori_tema_rovid_osszefoglalas"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6"
  }, [_c('comboboxV2', {
    attrs: {
      "label": "Kutatási/művészeti téma tudományterületi besorolása",
      "id": "tudomanyterulet",
      "name": "tudomanyterulet",
      "options": _vm.tudomanyteruletek
    },
    on: {
      "onChange": function($event) {
        _vm.tudomanyAgak(true)
      }
    },
    model: {
      value: (_vm.form.values.tudomanyterulet),
      callback: function($$v) {
        _vm.form.values.tudomanyterulet = $$v
      },
      expression: "form.values.tudomanyterulet"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6"
  }, [_c('comboboxV2', {
    attrs: {
      "label": "Kutatási/művészeti téma tudományági besorolása",
      "id": "tudomanyag",
      "name": "tudomanyag",
      "options": _vm.tudomanyagak
    },
    model: {
      value: (_vm.form.values.tudomanyag),
      callback: function($$v) {
        _vm.form.values.tudomanyag = $$v
      },
      expression: "form.values.tudomanyag"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  }, [_c('UploadHandler', {
    attrs: {
      "max_uploaded_files": "1",
      "accepted_files": "application/pdf,application/x-pdf",
      "errors": _vm.errors,
      "label": "Kutatási terv",
      "id": "kutatasi_terv",
      "name": "kutatasi_terv",
      "loaded_files": _vm.form.values.kutatasi_terv
    },
    on: {
      "change": function (value) {
        _vm.changeValue(value, 'kutatasi_terv');
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  }, [_c('UploadHandler', {
    attrs: {
      "max_uploaded_files": "1",
      "accepted_files": "application/pdf,application/x-pdf",
      "errors": _vm.errors,
      "label": "A doktori képzés keretében eddig elvégzett tevékenységek bemutatása",
      "id": "doktori_kepzesben_elvegzett_tevekenysegek",
      "name": "doktori_kepzesben_elvegzett_tevekenysegek",
      "loaded_files": _vm.form.values.doktori_kepzesben_elvegzett_tevekenysegek
    },
    on: {
      "change": function (value) {
        _vm.changeValue(value, 'doktori_kepzesben_elvegzett_tevekenysegek');
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  }, [_c('UploadHandler', {
    attrs: {
      "max_uploaded_files": "1",
      "accepted_files": "application/pdf,application/x-pdf",
      "errors": _vm.errors,
      "label": "A pályázó szakmai és tudományos önéletrajza",
      "id": "palyazo_onletrajz",
      "name": "palyazo_onletrajz",
      "loaded_files": _vm.form.values.palyazo_onletrajz
    },
    on: {
      "change": function (value) {
        _vm.changeValue(value, 'palyazo_onletrajz');
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  }, [_c('UploadHandler', {
    attrs: {
      "max_uploaded_files": "1",
      "accepted_files": "application/pdf,application/x-pdf",
      "errors": _vm.errors,
      "label": "Publikációs lista",
      "id": "palyazo_publikacios_lista",
      "name": "palyazo_publikacios_lista",
      "loaded_files": _vm.form.values.palyazo_publikacios_lista
    },
    on: {
      "change": function (value) {
        _vm.changeValue(value, 'palyazo_publikacios_lista');
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  }, [_c('UploadHandler', {
    attrs: {
      "max_uploaded_files": "10",
      "accepted_files": "application/pdf,application/x-pdf",
      "errors": _vm.errors,
      "label": "Egyéb csatolni kívánt dokumentumok",
      "id": "palyazo_egyeb_dokumentumok",
      "name": "palyazo_egyeb_dokumentumok",
      "loaded_files": _vm.form.values.palyazo_egyeb_dokumentumok
    },
    on: {
      "change": function (value) {
        _vm.changeValue(value, 'palyazo_egyeb_dokumentumok');
      }
    }
  })], 1), _vm._v(" "), _vm._m(8), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  }, [_c('comboboxV2', {
    attrs: {
      "label": "Pályázó további ösztöndíj",
      "id": "palyazo_tovabbi_osztondij",
      "name": "palyazo_tovabbi_osztondij",
      "options": _vm.palyazo_tovabbi_osztondij_opciok
    },
    on: {
      "onChange": _vm.tovabbiOsztondijValt
    },
    model: {
      value: (_vm.form.values.palyazo_tovabbi_osztondij),
      callback: function($$v) {
        _vm.form.values.palyazo_tovabbi_osztondij = $$v
      },
      expression: "form.values.palyazo_tovabbi_osztondij"
    }
  })], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.tovabbiOsztondijNyertes() || _vm.tovabbiOsztondijElbirlasFolyamatban()),
      expression: "tovabbiOsztondijNyertes() || tovabbiOsztondijElbirlasFolyamatban()"
    }],
    staticClass: "col-xs-6"
  }, [_c('inputbox', {
    attrs: {
      "label": "Ösztöndíj megnevezése",
      "errors": _vm.errors,
      "id": "palyazo_tovabbi_osztondij_megnevezese",
      "name": "palyazo_tovabbi_osztondij_megnevezese"
    },
    model: {
      value: (_vm.form.values.palyazo_tovabbi_osztondij_megnevezese),
      callback: function($$v) {
        _vm.form.values.palyazo_tovabbi_osztondij_megnevezese = $$v
      },
      expression: "form.values.palyazo_tovabbi_osztondij_megnevezese"
    }
  })], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.tovabbiOsztondijNyertes() || _vm.tovabbiOsztondijElbirlasFolyamatban()),
      expression: "tovabbiOsztondijNyertes() || tovabbiOsztondijElbirlasFolyamatban()"
    }],
    staticClass: "col-xs-6"
  }, [_c('inputbox', {
    attrs: {
      "label": "Ösztöndíj időszak",
      "errors": _vm.errors,
      "id": "palyazo_tovabbi_osztondij_idoszak",
      "name": "palyazo_tovabbi_osztondij_idoszak"
    },
    model: {
      value: (_vm.form.values.palyazo_tovabbi_osztondij_idoszak),
      callback: function($$v) {
        _vm.form.values.palyazo_tovabbi_osztondij_idoszak = $$v
      },
      expression: "form.values.palyazo_tovabbi_osztondij_idoszak"
    }
  })], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.tovabbiOsztondijNyertes() || _vm.tovabbiOsztondijElbirlasFolyamatban()),
      expression: "tovabbiOsztondijNyertes() || tovabbiOsztondijElbirlasFolyamatban()"
    }],
    staticClass: "col-xs-6"
  }, [_c('inputbox', {
    attrs: {
      "label": "Ösztöndíj összeg",
      "errors": _vm.errors,
      "id": "palyazo_tovabbi_osztondij_osszeg",
      "name": "palyazo_tovabbi_osztondij_osszeg",
      "regexp_filter": "[0-9]+"
    },
    model: {
      value: (_vm.form.values.palyazo_tovabbi_osztondij_osszeg),
      callback: function($$v) {
        _vm.form.values.palyazo_tovabbi_osztondij_osszeg = $$v
      },
      expression: "form.values.palyazo_tovabbi_osztondij_osszeg"
    }
  })], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.tovabbiOsztondijElbirlasFolyamatban()),
      expression: "tovabbiOsztondijElbirlasFolyamatban()"
    }],
    staticClass: "col-xs-6"
  }, [_c('inputbox', {
    attrs: {
      "autocomplete": "off",
      "datepicker": true,
      "datepickeropts": {
        'yearRange': '-0:+5',
        'changeYear': 'true',
        'changeMonth': 'true'
      },
      "label": "Döntés várható időpontja",
      "errors": _vm.errors,
      "id": "palyazo_tovabbi_osztondij_dontes_idopont",
      "name": "palyazo_tovabbi_osztondij_dontes_idopont"
    },
    model: {
      value: (_vm.form.values.palyazo_tovabbi_osztondij_dontes_idopont),
      callback: function($$v) {
        _vm.form.values.palyazo_tovabbi_osztondij_dontes_idopont = $$v
      },
      expression: "form.values.palyazo_tovabbi_osztondij_dontes_idopont"
    }
  })], 1), _vm._v(" "), _vm._m(9), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "info-box download"
  }, [_c('a', {
    attrs: {
      "href": "javascript:void(0)",
      "title": "Pályázói nyilatkozat letöltés"
    },
    on: {
      "click": function($event) {
        _vm.dokumentumGeneralas('2.sz.melleklet_palyazoi_nyilatkozat_EKÖP-KDP-2025')
      }
    }
  }, [_c('span', {
    staticClass: "highlight"
  }, [_vm._v("Pályázói nyilatkozat")]), _vm._v(" letöltés\n            ")])]), _vm._v(" "), _c('div', {
    staticClass: "info-box download"
  }, [_c('a', {
    attrs: {
      "href": "javascript:void(0)",
      "title": "Kutatási terv letöltés"
    },
    on: {
      "click": function($event) {
        _vm.dokumentumGeneralas('3.sz.melleklet_kutatasi_terv_EKÖP-KDP-2025')
      }
    }
  }, [_c('span', {
    staticClass: "highlight"
  }, [_vm._v("Kutatási terv")]), _vm._v(" letöltés\n            ")])]), _vm._v(" "), _c('div', {
    staticClass: "info-box download"
  }, [_c('a', {
    attrs: {
      "href": "javascript:void(0)",
      "title": "Doktori iskola nyilatkozat letöltés"
    },
    on: {
      "click": function($event) {
        _vm.dokumentumGeneralas('4.sz.melleklet_doktori_iskola_nyilatkozat_EKÖP-KDP-2025')
      }
    }
  }, [_c('span', {
    staticClass: "highlight"
  }, [_vm._v("Doktori iskola nyilatkozat")]), _vm._v(" letöltés\n            ")])]), _vm._v(" "), _c('div', {
    staticClass: "info-box download"
  }, [_c('a', {
    attrs: {
      "href": "javascript:void(0)",
      "title": "Témavezetői feladatok ellátásáról szóló nyilatkozat letöltés"
    },
    on: {
      "click": function($event) {
        _vm.dokumentumGeneralas('5.sz.melleklet_temavezetoi_nyilatkozat_EKÖP-KDP-2025')
      }
    }
  }, [_c('span', {
    staticClass: "highlight"
  }, [_vm._v("Témavezetői feladatok ellátásáról szóló nyilatkozat")]), _vm._v(" letöltés\n            ")])]), _vm._v(" "), _c('div', {
    staticClass: "info-box download"
  }, [_c('a', {
    attrs: {
      "href": "javascript:void(0)",
      "title": "Munkáltatói nyilatkozat letöltés"
    },
    on: {
      "click": function($event) {
        _vm.dokumentumGeneralas('6.sz.melleklet_munkaltatoi_nyilatkozat_EKÖP-KDP-2025')
      }
    }
  }, [_c('span', {
    staticClass: "highlight"
  }, [_vm._v("Munkáltatói nyilatkozat")]), _vm._v(" letöltés\n            ")])]), _vm._v(" "), _c('div', {
    staticClass: "info-box download"
  }, [_c('a', {
    attrs: {
      "href": "javascript:void(0)",
      "title": "Szakértői feladatok ellátásáról szóló nyilatkozat letöltés"
    },
    on: {
      "click": function($event) {
        _vm.dokumentumGeneralas('7.sz.melleklet_szakertoi_nyilatkozat_EKÖP-KDP-2025')
      }
    }
  }, [_c('span', {
    staticClass: "highlight"
  }, [_vm._v("Szakértői feladatok ellátásáról szóló nyilatkozat")]), _vm._v(" letöltés\n            ")])]), _vm._v(" "), _vm._m(10)]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  }, [_c('UploadHandler', {
    attrs: {
      "max_uploaded_files": "1",
      "accepted_files": "application/pdf,application/x-pdf",
      "errors": _vm.errors,
      "label": "Doktori iskola nyilatkozata",
      "id": "doktori_iskola_nyilatkozat",
      "name": "doktori_iskola_nyilatkozat",
      "loaded_files": _vm.form.values.doktori_iskola_nyilatkozat
    },
    on: {
      "change": function (value) {
        _vm.changeValue(value, 'doktori_iskola_nyilatkozat');
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  }, [_c('UploadHandler', {
    attrs: {
      "max_uploaded_files": "1",
      "accepted_files": "application/pdf,application/x-pdf",
      "errors": _vm.errors,
      "label": "Témavezetői nyilatkozat",
      "id": "temavezeto_nyilatkozat",
      "name": "temavezeto_nyilatkozat",
      "loaded_files": _vm.form.values.temavezeto_nyilatkozat
    },
    on: {
      "change": function (value) {
        _vm.changeValue(value, 'temavezeto_nyilatkozat');
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  }, [_c('UploadHandler', {
    attrs: {
      "max_uploaded_files": "1",
      "accepted_files": "application/pdf,application/x-pdf",
      "errors": _vm.errors,
      "label": "Munkáltatói nyilatkozat a Munkáltató képviselője által aláírva",
      "id": "munkaltatoi_nyilatkozat",
      "name": "munkaltatoi_nyilatkozat",
      "loaded_files": _vm.form.values.munkaltatoi_nyilatkozat
    },
    on: {
      "change": function (value) {
        _vm.changeValue(value, 'munkaltatoi_nyilatkozat');
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  }, [_c('UploadHandler', {
    attrs: {
      "max_uploaded_files": "1",
      "accepted_files": "application/pdf,application/x-pdf",
      "errors": _vm.errors,
      "label": "Szakértői nyilatkozat",
      "id": "szakertoi_nyilatkozat",
      "name": "szakertoi_nyilatkozat",
      "loaded_files": _vm.form.values.szakertoi_nyilatkozat
    },
    on: {
      "change": function (value) {
        _vm.changeValue(value, 'szakertoi_nyilatkozat');
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  }, [_c('UploadHandler', {
    attrs: {
      "max_uploaded_files": "1",
      "accepted_files": "application/pdf,application/x-pdf",
      "errors": _vm.errors,
      "label": "Pályázói nyilatkozat",
      "id": "palyazo_nyilatkozat",
      "name": "palyazo_nyilatkozat",
      "loaded_files": _vm.form.values.palyazo_nyilatkozat
    },
    on: {
      "change": function (value) {
        _vm.changeValue(value, 'palyazo_nyilatkozat');
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticStyle: {
      "display": "flex",
      "justify-content": "space-between",
      "align-items": "center"
    }
  }, [_c('button', {
    staticClass: "button",
    attrs: {
      "disabled": !_vm.save_enabled,
      "type": "button",
      "name": "kuld"
    },
    on: {
      "click": function($event) {
        _vm.save(0)
      }
    }
  }, [_vm._v("Mentés")]), _vm._v(" "), _c('button', {
    staticClass: "button",
    attrs: {
      "disabled": !_vm.save_enabled,
      "type": "button",
      "name": "kuld"
    },
    on: {
      "click": function($event) {
        _vm.save(1)
      }
    }
  }, [_vm._v("Véglegesít")])])])])]) : _vm._e(), _vm._v(" "), (_vm.fill_info != '') ? _c('div', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "form-title"
  }, [_vm._v(_vm._s(_vm.form.name))]), _vm._v(" "), _c('div', {
    staticClass: "article-text",
    domProps: {
      "innerHTML": _vm._s(_vm.fill_info)
    }
  })])])]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12"
  }, [_c('h5', {
    staticClass: "form-block-title"
  }, [_vm._v("\n            Alapadatok\n          ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12"
  }, [_c('h5', {
    staticClass: "form-block-title"
  }, [_vm._v("\n            Pályázói adatok\n          ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12"
  }, [_c('h5', {
    staticClass: "form-block-title"
  }, [_vm._v("\n            EKÖP-KDP jogviszony és Doktori képzés adatai\n          ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12"
  }, [_c('h5', {
    staticClass: "form-block-title"
  }, [_vm._v("\n            Doktori Iskola adatai\n          ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12"
  }, [_c('h5', {
    staticClass: "form-block-title"
  }, [_vm._v("\n            A doktori témavezető adatai (a témavezető tudományos és szakmai életútjának bemutatásához az önéletrajzának csatolása szükséges, amelyben a témavezetésével fokozatot szerzettek névsora, doktori témájuk és a fokozatszerzés éve feltüntetésre kerül)\n          ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12"
  }, [_c('h5', {
    staticClass: "form-block-title"
  }, [_vm._v("\n            A munkáltatóra vonatkozó adatok\n          ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12"
  }, [_c('h5', {
    staticClass: "form-block-title"
  }, [_vm._v("\n            A szakértő adatai (a szakértő szakmai életútjának bemutatásához az önéletrajzának csatolása szükséges, amelyben amennyiben releváns, a doktori fokozatot szerzettek névsora, doktori témájuk és a fokozatszerzés éve feltüntetésre kerül)\n          ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12"
  }, [_c('h5', {
    staticClass: "form-block-title"
  }, [_vm._v("\n            A pályázó korábbi eredményei és kutatási témája (a pályázó legmagasabb képzettségi szintjére vonatkozó adatok)\n          ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12"
  }, [_c('h5', {
    staticClass: "form-block-title"
  }, [_vm._v("\n            A pályázó további ösztöndíjainak adatai (a pályázó további ösztöndíjaira vonatkozó adatok (amennyiben releváns))\n          ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12"
  }, [_c('h5', {
    staticClass: "form-block-title"
  }, [_vm._v("\n            Nyilatkozatok (Az alábbi nyilakozatokat a korábbi oldalakon megadott adatok alapján generálja a rendszer a letöltés gombra kattintva, ezért a dokumentumok letöltését megelőzően bizonyosodjon meg arról, hogy a korábbi oldalakon minden szükséges mezőt hiánytalanul és pontosan töltött ki. A letöltött nyilatkozatokat a megfelelő személyek aláírását követően tudja visszatölteni a kijelölt helyre.)\n          ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "info-box download"
  }, [_c('a', {
    attrs: {
      "target": "_blank",
      "href": "assets/files/8.sz.melleklet_tudomanyag_besorolas_EKÖP-KDP-2025.docx",
      "title": "Tudományági besorolás letöltés"
    }
  }, [_c('span', {
    staticClass: "highlight"
  }, [_vm._v("Tudományági besorolás")]), _vm._v(" letöltés\n            ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3579fcbd"}!./~/vue-loader/lib/selector.js?type=template&index=0!./components/competition/doktori_program.vue
// module id = 353
// module chunks = 0